import { Dialog } from 'radix-ui';
import { useNamespaceCopy } from '@/i18n/ns';
import pageCatalog from '@/i18n/ns/connections-page';
import { WorkspaceIcon } from '../icons';
import { hashParam } from '../agent-connections/hash-param';
import { CodingAgentsSection, KnowledgeClientsSection } from '../agent-connections';
import { ConnectionMark } from './connection-mark';

/** `?setup=knowledge-client` (from Knowledge and the chat card) opens the assistants' setup. */
export function assistantsSetupRequested() {
  return hashParam('setup') === 'knowledge-client';
}

/** `?agent=<grantId>` (from an Agent request and Agent activity) opens the assistants' sheet on that agent. */
export function agentRequested(): string | null {
  return hashParam('agent');
}

/**
 * Other AI assistants: agents outside Poneva that read approved company knowledge over MCP, and
 * the person's coding agents. The other direction from every other connection on the page, so it
 * sits behind its own tile instead of in the list.
 */
export function OtherAssistantsSheet({ onClose }: { onClose: () => void }) {
  const copy = useNamespaceCopy(pageCatalog);
  return (
    <Dialog.Root open onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="ws-conn-panel-scrim" />
        <Dialog.Content
          className="ws-portal ws-conn-panel is-wide"
          aria-describedby="ws-conn-assistants-intro"
        >
          <div className="ws-conn-panel-top">
            <Dialog.Close className="ws-conn-icon-button" aria-label={copy.close}>
              <WorkspaceIcon name="close" size={17} />
            </Dialog.Close>
          </div>
          <header className="ws-conn-panel-hero">
            <ConnectionMark name={copy.assistantsTitle} glyph="agents" size="xl" />
            <div>
              <Dialog.Title className="ws-conn-panel-title">{copy.assistantsTitle}</Dialog.Title>
              <p className="ws-conn-panel-identity" id="ws-conn-assistants-intro">
                {copy.assistantsSheetIntro}
              </p>
            </div>
          </header>
          <div className="ws-conn-panel-body ws-conn-assistants">
            <KnowledgeClientsSection />
            <CodingAgentsSection />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
